import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    fullSize: {
        width: '100%',
    },
    statusTimeRangePicker: {
        cursor: 'pointer',
        '& .selection-indicator-frame': {
            strokeWidth: 1,
            stroke: '#777',
        },

        '& .highcharts-point': {
            opacity: 0.7,

            '&.selected-time': {
                opacity: 1,
            },
        },

        '& .highcharts-point-hover': {
            opacity: 1,
        },

        '& .selected-time': {
            paddingBottom: 10,
        },

        '& .selection-indicator-label': {
            fontWeight: 'bold',
            fontSize: 14,
            fill: theme.palette.text.primary,
        },

        '& .hidden': {
            visibility: 'hidden',
        },
    },
    statusNoSelection: {
        '& .highcharts-point': {
            opacity: 0.7,

            '&.selected-time': {
                opacity: 1,
            },
        },

        '& .highcharts-point-hover': {
            opacity: 1,
        },
    },
}));
